import React from "react";

// Reusable E3 wordmark logo (green→blue gradient)
export const E3Logo = ({ className = "h-9 w-auto", showTagline = false }) => (
    <div className={`flex items-center gap-3 ${className}`}>
        <svg
            viewBox="0 0 56 56"
            className="h-9 w-9"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <defs>
                <linearGradient id="e3grad" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#6abf4b" />
                    <stop offset="100%" stopColor="#2b8fb0" />
                </linearGradient>
            </defs>
            <circle cx="28" cy="28" r="26" fill="none" stroke="url(#e3grad)" strokeWidth="2.5" />
            <text
                x="50%"
                y="55%"
                textAnchor="middle"
                dominantBaseline="middle"
                fontFamily="Fraunces, serif"
                fontSize="24"
                fontWeight="600"
                fill="url(#e3grad)"
            >
                E3
            </text>
        </svg>
        <div className="leading-tight">
            <div className="font-serif text-xl font-medium tracking-tight text-stone-900">
                Earth Energy Engine
            </div>
            {showTagline && (
                <div className="text-[0.68rem] uppercase tracking-[0.22em] text-stone-500 mt-0.5">
                    Powering Tomorrow, Naturally
                </div>
            )}
        </div>
    </div>
);
